<div class="automatic-osm-map">
  <div #mapContainer class="automatic-osm-map__container"></div>

  <div class="automatic-osm-map__loading" *ngIf="loading">
    <app-loader [position]="'reset'"></app-loader>
    <span>Загрузка OpenStreetMap...</span>
  </div>

  <div class="automatic-osm-map__error" *ngIf="errorText">
    {{ errorText }}
  </div>
</div>
